import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoManifoldFullMono = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 605.806 150",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M221.5 37.5H234.833L244.417 91.9444C245.111 96.1111 245.806 99.1667 245.944 102.778H246.361C246.5 99.0278 247.056 95.9722 247.889 91.9444L257.472 37.5H270.806V112.5H263.028V65.4167C263.028 60.6944 263.028 49.7222 263.306 45H262.75C262.333 49.3056 262.056 51.25 260.944 58.4722L250.944 112.5H241.5L231.5 58.4722C230.389 51.25 229.833 45.4167 229.694 45H229.278C229.417 49.7222 229.417 60.6944 229.417 65.4167V112.5H221.639L221.5 37.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M313.861 83.75L308.861 57.5C308.167 53.75 307.75 50 307.333 46.1111H307.056C306.639 50 306.222 53.75 305.528 57.5L300.528 83.75C300.528 83.75 313.861 83.75 313.861 83.75ZM315.25 90.6944H299.278L295.111 112.5H286.5L301.778 37.5H312.472L327.75 112.5H319.139L315.25 90.6944Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M343.583 37.5H353.167L370.667 86.6667C372.194 90.9722 373.028 95 373.861 99.7222H374.139C373.444 93.4722 373.167 87.3611 373.167 80.5556V37.5H381.222V112.5H372.194L354.278 61.8056C352.333 56.5278 351.778 53.4722 350.944 49.0278H350.667C351.361 54.1667 351.778 58.1944 351.778 63.4722V112.5H343.722L343.583 37.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M399.694 112.5H408.167V37.5H399.694V112.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M434.972 44.8611V70.1389H453.861V77.5H434.972V112.5H426.639V37.5H455.667V44.8611H434.972Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M499 93.1944V56.8056C499 48.0556 495.25 42.9167 488.444 42.9167C481.639 42.9167 478.028 48.0556 478.028 56.8056V93.1944C478.028 101.806 481.778 107.083 488.444 107.083C495.25 106.944 499 101.944 499 93.1944ZM469.278 92.5V57.5C469.278 43.3333 476.083 35.6944 488.444 35.6944C500.944 35.6944 507.75 43.3333 507.75 57.5V92.6389C507.75 106.806 500.944 114.444 488.444 114.444C476.083 114.306 469.278 106.528 469.278 92.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M524.972 37.5H533.444V104.583H552.889V112.5H524.972V37.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M583.444 105.556C592.889 105.556 597.056 98.6111 597.056 83.6111V66.1111C597.056 50.9722 592.889 44.3056 583.444 44.3056H577.056V105.417H583.444V105.556ZM568.583 37.5H584.556C598.861 37.5 605.806 46.8056 605.806 66.1111V82.3611C605.806 102.5 598.583 112.5 584.278 112.5H568.583V37.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M221.5 127.222H270.806V119.861H221.5V127.222Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M43.3333 57.9167L0 98.75L29.5833 115.833L43.3333 57.9167Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M83.8889 15.5556L56.9444 0L5.27778 89.7222L44.5833 52.6389L83.8889 15.5556Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M86.6667 132.917L143.611 150V115.833L86.6667 132.917Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M29.5833 118.889V150H133.194L81.3889 134.444L29.5833 118.889Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M116.25 0L86.6667 17.0833L129.861 57.9167L116.25 0Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M121.389 9.02778L133.889 61.6667L146.25 114.167L173.194 98.75L121.389 9.02778Z",
			fill: "currentColor"
		})
	]
});
export default SvgLogoManifoldFullMono;
